export default __webpack_public_path__ + "static/media/aws-elastic-cache.a6f0ab3b.svg";